:where(.header-button) {
  -webkit-user-select: text;
          user-select: text;
  position: relative;
  cursor: pointer;
  display: block;
  width: 100%;
  border-radius: inherit;
}

.header__content {
  text-align: left;
  display: flex;
  align-items: center;
}

.body {
  overflow: hidden;
}

.body--animated {
  @media (prefers-reduced-motion: no-preference) {
    transition: height var(--dds-motion-surface);
  }
}

.body--hidden {
  display: none;
}
